export class SearchHomePageVersionBreakdownRequest {
    Version: string;
    OnlyYard: boolean;
}
